import Vue from 'vue';
import App from './App.vue';
import router from './router.js';
import store from './vuex';
import 'aframe';
import 'aframe-html-shader';
import 'aframe-physics-system/dist/aframe-physics-system';
import 'aframe-extras';
// analytics
import VueGtag from 'vue-gtag';
Vue.use(
  VueGtag, {
    config: { id: 'G-VERH6ZF937' }
  },
  router
);

Vue.config.productionTip = false;

// massのエラー監視
// ネット速度によってエラーが出た場合1度だけリロードする(無限ループ回避)
window.addEventListener('error', (event) => {
  if (event.message.includes('reading \'mass\'')) {
    const retried = localStorage.getItem('mass_error_retried');
    if (retried === 'true') return;
    console.warn('Mass read error detected. The page will reload once.');
    localStorage.setItem('mass_error_retried', 'true');
    location.reload();
  }
});
// ロード後、数秒待ってからリセット（エラーが出ない＝正常と判断）
window.addEventListener('load', () => {
  setTimeout(() => {
    localStorage.removeItem('mass_error_retried');
    console.log('Reload flag has been cleared.');
  }, 10000); // 10秒後に解除（必要に応じて調整）
});

//A-Frameのカスタムコンポーネント
/*******************************************
 * カスタムコンポーネント:arrow-controls
 * 移動処理用
 ******************************************/
// ユーザー入力に応じてオブジェクトを移動（速度は1秒あたりの単位で計算）
window.AFRAME.registerComponent('arrow-controls', {
  schema: { speed: { default: 2 } },  // 通常速度（加速前）
  init: function () {
    this.keys = {};         // 押されているキーの状態を保持
    this.virtualKeys = {};  // タブレット端末の方向キー用
    this.camera = null;     // カメラの object3D を格納
    // キーが押されたら対応するフラグを true に
    window.addEventListener('keydown', e => {
      this.keys[e.code] = true;
    });
    // キーが離されたら対応するフラグを false に
    window.addEventListener('keyup', e => {
      this.keys[e.code] = false;
    });
    // フォーカスが外れたらキーをリセット
    window.addEventListener('blur', () => {
      this.keys = {};
      this.virtualKeys = {};
    });
    // dynamic-body の初期化後に angularFactor を設定
    this.el.addEventListener('body-loaded', () => {
      if (this.el.body) {
        // 回転させない（全軸固定）
        this.el.body.angularFactor.set(0, 0, 0);
        this.body = this.el.body;
      }
    });
  },
  tick: function (time, dt) {
    if (!dt || isNaN(dt)) return;  // 無効な時間なら何もしない
    // dynamic-body が無効ならスキップ
    const body = this.el.body;
    if (!body || !body.velocity) return;
    // 初回のみ、カメラの object3D を取得
    if (!this.yawObject) {
      const camEl = this.el.querySelector('[camera]');
      if (!camEl || !camEl.components['look-controls']) return;
      this.yawObject = camEl.components['look-controls'].yawObject;
    }
    // 移動速度計算 ShiftLeft / ShiftRight の状態から判定
    const baseSpeed = this.data.speed;
    const isBoosting = !!this.keys['ShiftLeft'] || !!this.keys['ShiftRight']; // true = どちらかのShift押下中
    const currentSpeed = isBoosting ? baseSpeed * 2 : baseSpeed;  // 加速時は2倍
    const move = currentSpeed;  // フレーム間の移動距離
    // 方向行列 (rig + yaw)
    const matrix = new THREE.Matrix4();
    const rigRotationY = this.el.object3D.rotation.y;
    const yawRotationY = this.yawObject.rotation.y;
    matrix.makeRotationFromEuler(new THREE.Euler(0, rigRotationY + yawRotationY, 0));
    // カメラ基準の前後左右ベクトル
    const forward = new THREE.Vector3(0, 0, -1).applyMatrix4(matrix).setY(0).normalize(); // 前方向ベクトル
    const right = new THREE.Vector3(1, 0, 0).applyMatrix4(matrix).setY(0).normalize();    // 右方向ベクトル
    // 移動ベクトル
    const velocity = new THREE.Vector3();
    // 押下状態
    const forwardPressed = (this.keys['KeyW'] || this.keys['ArrowUp'] || this.virtualKeys['up']);
    const backwardPressed = (this.keys['KeyS'] || this.keys['ArrowDown'] || this.virtualKeys['down']);
    const leftPressed = (this.keys['KeyA'] || this.keys['ArrowLeft'] || this.virtualKeys['left']);
    const rightPressed = (this.keys['KeyD'] || this.keys['ArrowRight'] || this.virtualKeys['right']);
    // 前後左右入力
    if (forwardPressed && !backwardPressed) velocity.add(forward);
    if (backwardPressed && !forwardPressed) velocity.add(forward.clone().negate());
    if (leftPressed && !rightPressed) velocity.add(right.clone().negate());
    if (rightPressed && !leftPressed) velocity.add(right);
    // 正規化して速度を掛ける
    if (velocity.lengthSq() > 0) {
      velocity.normalize().multiplyScalar(move);
    }
    // y方向の速度は維持（落下やジャンプ用）
    const currentY = body.velocity.y;
    body.velocity.set(velocity.x, currentY, velocity.z);
  },
  // 仮想キー操作メソッド
  startVirtualKey: function (direction) {
    this.virtualKeys[direction] = true;
  },
  stopVirtualKey: function (direction) {
    this.virtualKeys[direction] = false;
  }
});
/*******************************************
 * カスタムコンポーネント:virtual-joystick
 * スマホ移動用
 ******************************************/
window.AFRAME.registerComponent('virtual-joystick', {
  schema: {
    baseRadius: { default: 80 },     // ベース半径(px)  CSSの直径と一致させると自然
    stickRadius:{ default: 42 },     // スティック半径(px)
    deadZone:   { default: 12 },     // 無効域(px)
    eightWay:   { default: false }   // trueにすると8方向スナップ
  },
  init: function () {
    // arrow-controls の keys を共有
    const ac = this.el.components['arrow-controls'];
    if (!ac) { console.warn('arrow-controls が必要です'); return; }
    this.keys = ac.keys;
    // DOMを生成
    this.wrap = document.createElement('div');
    this.wrap.className = 'vj-wrap';
    this.base = document.createElement('div');
    this.base.className = 'vj-base';
    this.stick = document.createElement('div');
    this.stick.className = 'vj-stick';
    this.base.appendChild(this.stick);
    this.wrap.appendChild(this.base);
    document.body.appendChild(this.wrap);
    // スティックのサイズ設定
    const baseD  = this.data.baseRadius * 2;
    const stickD = this.data.stickRadius * 2;
    this.wrap.style.width  = baseD + 'px';
    this.wrap.style.height = baseD + 'px';
    this.base.style.width  = baseD + 'px';
    this.base.style.height = baseD + 'px';
    this.stick.style.width  = stickD + 'px';
    this.stick.style.height = stickD + 'px';
    this.stick.style.marginLeft = (-this.data.stickRadius) + 'px';
    this.stick.style.marginTop  = (-this.data.stickRadius) + 'px';
    // 状態
    this.activeId = null;
    this.center = { x: 0, y: 0 }; // ベース中心
    this.vec = { x:0, y:0 };      // -1..1 のアナログ値
    // バインド
    this.onStart = this.onStart.bind(this);
    this.onMove  = this.onMove.bind(this);
    this.onEnd   = this.onEnd.bind(this);
    // リスナ（ベースのみ反応）
    this.base.addEventListener('touchstart', this.onStart, {passive:false});
    this.base.addEventListener('touchmove',  this.onMove,  {passive:false});
    this.base.addEventListener('touchend',   this.onEnd,   {passive:false});
    this.base.addEventListener('touchcancel',this.onEnd,   {passive:false});
    // マウス操作にも対応（PCデバッグ用）
    this.base.addEventListener('mousedown', (e)=>{
      this.activeId = 'mouse';
      const r = this.base.getBoundingClientRect();
      this.center.x = r.left + r.width/2;
      this.center.y = r.top  + r.height/2;
      this.updateFromPoint(e.clientX, e.clientY);
      window.addEventListener('mousemove', this.onMouseMove, {passive:false});
      window.addEventListener('mouseup',   this.onMouseUp,   {passive:false});
      e.preventDefault();
    });
    this.onMouseMove = (e)=>{ if(this.activeId==='mouse'){ this.updateFromPoint(e.clientX,e.clientY); e.preventDefault(); } };
    this.onMouseUp   = (e)=>{ if(this.activeId==='mouse'){ this.resetStick(); this.activeId=null; e.preventDefault(); } };
  },
  updateFromPoint(clientX, clientY){
    const R  = this.data.baseRadius;
    const rS = this.data.stickRadius;
    const dx = clientX - this.center.x;
    const dy = clientY - this.center.y;
    const dist = Math.hypot(dx, dy);
    const dead = this.data.deadZone;
    // ベース円内に制限
    const clamped = dist > (R - rS) ? (R - rS) : dist;
    const angle = Math.atan2(dy, dx); // 右=0, 上= -PI/2
    // スティック位置
    const sx = Math.cos(angle) * clamped;
    const sy = Math.sin(angle) * clamped;
    this.stick.style.transform = `translate(${sx}px, ${sy}px)`;
    // デッドゾーン内は0
    if (dist <= dead) {
      this.vec.x = 0; this.vec.y = 0;
    } else {
      // -1..1 に正規化（x=右+, y=下+）
      const mag = (clamped - dead) / ((R - rS) - dead);
      this.vec.x = Math.cos(angle) * mag;
      this.vec.y = Math.sin(angle) * mag;
    }
    // optional: 8方向スナップ
    if (this.data.eightWay && (this.vec.x !== 0 || this.vec.y !== 0)) {
      const dirs = [
        [ 1, 0], [ 1,-1], [0,-1], [-1,-1],
        [-1, 0], [-1, 1], [0, 1], [ 1, 1]
      ];
      let best=[0,0], bestDot=-1;
      const len = Math.hypot(this.vec.x, this.vec.y) || 1;
      const nx = this.vec.x/len, ny=this.vec.y/len;
      for (const [dx8,dy8] of dirs){
        const l = Math.hypot(dx8,dy8); const dot = (nx*dx8 + ny*dy8)/l;
        if (dot>bestDot){ bestDot=dot; best=[dx8/l, dy8/l]; }
      }
      this.vec.x = best[0] * len;
      this.vec.y = best[1] * len;
    }
    // keysへ投影（視界基準の前: -Z, 右: +X の判定は arrow-controls 側で行うので、
    // ここでは「前後左右の意図」をブーリアン化）
    const deadBool = 0.15; // ブール化のしきい値
    const forward = (-this.vec.y) > deadBool;   // 上方向 = 前
    const backward= ( this.vec.y) > deadBool;   // 下方向 = 後
    const right   = ( this.vec.x) > deadBool;
    const left    = (-this.vec.x) > deadBool;
    this.keys['KeyW'] = this.keys['ArrowUp']    = forward;
    this.keys['KeyS'] = this.keys['ArrowDown']  = backward;
    this.keys['KeyD'] = this.keys['ArrowRight'] = right;
    this.keys['KeyA'] = this.keys['ArrowLeft']  = left;
  },
  onStart(e){
    // ベース中心を計算（固定UIなので毎回取得でもOK）
    const r = this.base.getBoundingClientRect();
    this.center.x = r.left + r.width/2;
    this.center.y = r.top  + r.height/2;
    // 最初の指を採用
    const t = e.changedTouches[0];
    this.activeId = t.identifier;
    this.updateFromPoint(t.clientX, t.clientY);
    e.preventDefault();
  },
  onMove(e){
    if (this.activeId == null) return;
    const t = [...e.touches].find(tt => tt.identifier === this.activeId);
    if (!t) return;
    this.updateFromPoint(t.clientX, t.clientY);
    e.preventDefault();
  },
  onEnd(e){
    if (this.activeId == null) return;
    const ended = [...e.changedTouches].some(tt => tt.identifier === this.activeId);
    if (!ended) return;
    this.resetStick();
    this.activeId = null;
    e.preventDefault();
  },
  resetStick(){
    this.stick.style.transform = 'translate(0px, 0px)';
    this.vec.x = this.vec.y = 0;
    this.keys['KeyW']=this.keys['ArrowUp']=
    this.keys['KeyS']=this.keys['ArrowDown']=
    this.keys['KeyA']=this.keys['ArrowLeft']=
    this.keys['KeyD']=this.keys['ArrowRight']=false;
  },
  remove () {
    this.resetStick();
    if (this.wrap)      this.wrap.remove();
    // これらは関数参照が存在するので呼んでも安全（登録されていなければ何も起きません）
    window.removeEventListener('mousemove', this.onMouseMove);
    window.removeEventListener('mouseup',   this.onMouseUp);
  }
});
/*******************************************
 * カスタムコンポーネント:touch-look-area
 * スマホ視点操作用
 ******************************************/
window.AFRAME.registerComponent('touch-look-area', {
  schema: { sensitivity: { default: 0.005 } },
  init() {
    this.active = null;
    this.yaw = null;
    this.pitch = null;
    const bind = (el, type, fn) =>
      el.addEventListener(type, fn, { passive: false });
    const setup = () => {
      const cam = this.el.querySelector('[camera]');
      if (!cam) return;
      const lc = cam.components['look-controls'];
      if (!lc || !lc.yawObject || !lc.pitchObject) return;
      this.yaw = lc.yawObject;
      this.pitch = lc.pitchObject;
    };
    // look-controls が載るまで待つ
    if (this.el.hasLoaded) {
      setup();
    } else {
      this.el.addEventListener('loaded', setup, { once: true });
    }
    const joyTop = () => {
      const el = document.querySelector('.vj-wrap');
      return el ? el.getBoundingClientRect().top : Infinity;
    };
    const onMove = (e) => {
      if (!this.active || !this.yaw || !this.pitch) return;
      const t = [...e.touches].find(x => x.identifier === this.active.id);
      if (!t) return;
      const dx = t.clientX - this.active.x;
      const dy = t.clientY - this.active.y;
      this.active.x = t.clientX;
      this.active.y = t.clientY;
      this.yaw.rotation.y   += dx * this.data.sensitivity;
      this.pitch.rotation.x -= dy * this.data.sensitivity;
      e.preventDefault();
    };
    const canvas = this.el.sceneEl.canvas;
    // ↑ canvas がまだ無いタイミングもあるので、無い時は loaded で再試行
    const attach = () => {
      const cvs = this.el.sceneEl.canvas;
      if (!cvs) return;
      bind(cvs, 'touchstart', (e) => {
        // ジョイスティックより上の領域だけで視点操作
        const t = e.changedTouches[0];
        if (t.clientY < joyTop()) {
          this.active = { id: t.identifier, x: t.clientX, y: t.clientY };
          e.preventDefault();
        }
      });
      bind(cvs, 'touchmove',  onMove);
      bind(cvs, 'touchend',   () => (this.active = null));
      bind(cvs, 'touchcancel',() => (this.active = null));
    };
    if (canvas) {
      attach();
    } else {
      this.el.sceneEl.addEventListener('render-target-loaded', attach, { once: true });
    }
  }
});
/*******************************************
 * カスタムコンポーネント:model-loader
 * 建物データロードイベント用
 ******************************************/
window.AFRAME.registerComponent('model-loader', {
  init: function () {
    this.el.addEventListener('model-loaded', () => {
      this.el.emit('glb-loaded'); // ← this が正しくコンポーネントを指す
      console.log('Finish model load');
    });
  }
});
/*******************************************
 * カスタムコンポーネント:position-listener
 * ポジションを見張る処理
 ******************************************/
window.AFRAME.registerComponent('position-listener', {
  tick() {
    // 現在のポジションを取得
    const newValue = this.el.getAttribute('position');
    // 小数点を四捨五入
    const newPosition = {
      x: Math.ceil(newValue.x),
      y: Math.ceil(newValue.y),
      z: Math.ceil(newValue.z)
    }
    // 文字列に置き換え
    const stringCoords = window.AFRAME.utils.coordinates.stringify({
      x: newPosition.x,
      y: newPosition.y,
      z: newPosition.z
    });
    // ポジションが変更しているかチェック
    if (this.lastValue !== stringCoords) {
      this.lastValue = stringCoords;
      // 変更がある場合はワープの位置をチェック
      // positionChanged(newPosition);
      this.el.emit('positionChanged', newPosition);
    }
  }
});

// a-frameのタグでVue CLIの警告を出さない
Vue.config.ignoredElements = [
  'a-scene',
  'a-entity',
  'a-camera',
  'a-cursor',
  'a-box',
  'a-sky',
  'a-plane',
  'a-assets',
  'a-marker',
  'a-marker-camera',
  'a-image',
  'a-video',
  'a-text',
  'a-light',
  'a-cone',
  'a-sphere',
  'a-videosphere'
];

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
